import { render, staticRenderFns } from "./groupForm.vue?vue&type=template&id=35bb207b&scoped=true"
import script from "./groupForm.vue?vue&type=script&lang=js"
export * from "./groupForm.vue?vue&type=script&lang=js"
import style0 from "./groupForm.vue?vue&type=style&index=0&id=35bb207b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35bb207b",
  null
  
)

export default component.exports